import type { IconProps } from '../types/IconProps.ts';
export const Shuffle: IconProps = {
    name: 'Shuffle',
    children: [
        `<path d="M2 18h4.93a2 2 0 0 0 1.66-.9l6.82-10.2a2 2 0 0 1 1.66-.9H22M10.1 9.14 8.6 6.89A2 2 0 0 0 6.92 6H2M22 18h-4.93a2 2 0 0 1-1.66-.9L14 15" />`,
        `<path d="m19 2 2.92 3.34a1 1 0 0 1 0 1.32L19 10M19 22l2.92-3.34a1 1 0 0 0 0-1.32L19 14" />`,
    ]
};